import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  connect() {
    const lastSubmission = sessionStorage.getItem('lastPasswordReset')
    if (lastSubmission && Date.now() - lastSubmission < 300000) {
     // this.disableButton()
    }
  }

  disableButton() {
    this.submitTarget.disabled = true
    this.submitTarget.textContent = "Please wait..."
  }

  submit(e) {
    sessionStorage.setItem('lastPasswordReset', Date.now())
   // this.disableButton()
  }
}